import React from 'react'
import { BookIcon, CommunityIcon, SupportContactIcon, SupportIcon } from '~/constants/icon'
import { Button } from './Button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from './dropdowns/DropdownMenu'

interface SupportButtonProps {
  className?: string
}

export const SupportButton: React.FC<SupportButtonProps> = ({ className }) => {
  const supportItems = [
    {
      icon: <BookIcon />,
      label: 'Documentation',
      onClick: () => {
        window.open('https://docs.curietech.ai', '_blank', 'noopener,noreferrer')
      }
    },
    {
      icon: <SupportContactIcon />,
      label: 'Contact Support',
      onClick: () => {
        window.open('mailto:support@curietech.net?subject=Ask%20for%20support', '_blank')
      }
    },
    {
      icon: <CommunityIcon />,
      label: 'Join Community',
      onClick: () => {
        window.open(
          'https://join.slack.com/t/curietechai-community/shared_invite/zt-3d3uvr8gw-6dlm6_NT57tTJ5Q_PJ9IjA',
          '_blank',
          'noopener,noreferrer'
        )
      }
    }
  ]

  return (
    <div className={`relative ${className || ''}`}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant='borderless'
            className='flex justify-center items-center gap-2 flex-[1_0_0] self-stretch px-4 py-2 h-9'
          >
            <SupportIcon />
            <div className='text-tokens-neutral-text-primary text-center text-[14px] font-medium leading-[22px]'>
              Support
            </div>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align='end' className='w-[200px]'>
          {supportItems.map((item, index) => (
            <DropdownMenuItem key={index} onClick={item.onClick} className='w-full'>
              <div className='flex items-center gap-2 w-full cursor-pointer'>
                <div className='flex-shrink-0 w-5 h-5 flex items-center justify-center'>
                  {item.icon}
                </div>
                <span className='font-medium'>{item.label}</span>
              </div>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
